<template>
  <div v-if="getSortType !== 'mostLiked'">
    <button @click="openApiRequest()" class="mt-4 mr-5 api-custom d-none d-md-block">API request
      <svg data-v-e7b11991="" data-v-363c04b8="" width="16" height="16" viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg" class="access-link-icon">
        <path data-v-e7b11991=""
          d="M14 2v4H6v36h36v-8h4v12H2V2h12Zm32 0v20h-4V8.667l-.201.404-16.97 16.97L22 23.214l16.97-16.97.484-.243H26V2h20Z">
        </path>
      </svg>
    </button>
  </div>
</template>

<script>
import { extractApiParams } from './ExportApiParams.ts'

export default {
  name: "SearchApiLink",
  props: {
    config: Object
  },
  computed: {
    getFacets() {
      return this.$store.getters[`${this.config.getFacets[0]}/${this.config.getFacets[1]}`];
    },
    getSortType() {
      return this.$store.getters['search/getSortType'];
    },
  },
  methods: {
    openApiRequest() {
      const { baseUrl, urlQuery, filter, params, includes, readableFacets } = extractApiParams({
        baseUrl: this.$env.api.baseUrl,
        route: this.$route,
        config: this.config,
        facets: this.getFacets,
      })

      // Open the API request in new Tab
      if (urlQuery.query) {
        window.open(baseUrl + "search?q=" + urlQuery.query + filter + params + (includes ? "&includes=" + includes : "") +
          "&facets=" + readableFacets, "_blank");
      } else {
        window.open(baseUrl + "search?q=" + filter + params + (includes ? "&includes=" + includes : "") +
          "&facets=" + readableFacets, "_blank");
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.api-custom {
  margin-top: 32px !important;
  border: none;
  background: none;
  padding: 0;
}
</style>
